export default function ConfirmBox({
  buttonText,
  text,
  extraText,
  open,
  setOpen,
  buttonHandler,
  extraButtonText,
  extraButtonHandler,
  setDeactivationReason = null,
  deactivationReason = null,
  checkValue = null
}) {
  const handleClose = () => {
    if (buttonHandler) {
      buttonHandler();
    } else {
      setOpen(false);
    }
  };

  return (
    open && (
      <div
        style={{ zIndex: 999 }}
        className="relative"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div
          className="fixed inset-0 bg-black-150 opacity-70 transition-opacity"
          aria-hidden="true"
        ></div>

        <div
          style={{ zIndex: 999 }}
          className="fixed inset-0 w-screen overflow-y-auto"
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="relative transform overflow-hidden rounded-lg bg-white shadow-xl transition-all py-12 px-10 w-full max-w-lg">
              <div className="bg-white  flex flex-col items-center justify-center">
                {extraText && (
                  <div className="bg-[#FFF2ED] rounded py-2 px-3 mb-4 max-w-max">
                    <p className="text-orange-150 text-sm font-semibold mb-0">
                      {extraText}
                    </p>
                  </div>
                )}
                <div className=" text-center">
                  <p className="text-xl font-semibold text-black mb-0">
                    {text}
                  </p>
                </div>
              </div>
              {setDeactivationReason && !checkValue && <div className="bg-white flex flex-col items-center justify-center mt-6">
                <textarea
                  className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-150"
                  rows="4"
                  placeholder={"Enter the reason for maintenance here..."}
                  value={deactivationReason}
                  onChange={(e) => setDeactivationReason(e.target.value)}
                />
              </div>}
              <div className="mt-6">
                <button
                  onClick={handleClose}
                  className="bg-orange-400 p-3 rounded-md text-lg font-bold mb-0 text-white"
                >
                  {buttonText}
                </button>
                {extraButtonHandler && (
                  <button
                    onClick={extraButtonHandler}
                    className="bg-gray-500 p-3 rounded-md text-lg font-bold mb-0 text-white ml-4"
                  >
                    {extraButtonText}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
}
